import { render } from "./Element.vue?vue&type=template&id=65b25472&scoped=true"
import script from "./Element.vue?vue&type=script&lang=js"
export * from "./Element.vue?vue&type=script&lang=js"

import "./Element.vue?vue&type=style&index=0&id=65b25472&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-meter-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b25472"],['__file',"src/assets/js/components/Form/Element.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "65b25472"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('65b25472', __exports__)) {
    api.reload('65b25472', __exports__)
  }
  
  module.hot.accept("./Element.vue?vue&type=template&id=65b25472&scoped=true", () => {
    api.rerender('65b25472', render)
  })

}


export default __exports__